import { Component, OnInit , Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/Subject';

import * as _ from 'underscore';
import * as moment from 'moment';
import { PagerService } from 'services/index'

import { Router } from '@angular/router';

import { GlobalService } from 'services/global.service';
import { AuthService } from 'services/auth.service';

@Component({
  selector: 'app-student-modal',
  templateUrl: './student-modal.component.html',
  styleUrls: []
})

export class StudentModalComponent {
  // pass from previous component
  studentId: string;
  courseId: string;
  questionId: number;
  questionDay: string;
  questionData: any;
  isUnableToAnswer : boolean;
  questionNo: string;
  questionPosition;
  questionTotal;
  //Next,Prevリンク用
  prev_question_item;
  next_question_item;
  //親へのイベント通知用
  @Output() clickPrevNextButton = new EventEmitter<any>();

  // declare in this component
  isChoose;
  questionImgUrl = "";
  feedbackImgUrl = "";
  feedbackText = "";
  feedbackText_under = "";
  Type3=false;//非表示式

  // class helpers
  questionHelper = new this.globalService.enumHelpers.QuestionType();
  choiceAnswerHelper = new this.globalService.enumHelpers.ChoiceAnswerType();
  circleNumberHelper = new this.globalService.enumHelpers.CircleNumberType();

  isAdmin: Boolean = (this.authService.role == "admin") ? true : false;
  
  constructor(
    private authService: AuthService,
    public bsModalRef: BsModalRef,
    private http:Http,
    private location: Location,
    private router: Router,
    private pagerService:PagerService,
    private globalService:GlobalService
    ) {
      
    }
  
  ngOnInit() {
    this.feedbackText = this.globalService.getFooterPattern(this.questionData);
    this.feedbackText_under = this.globalService.getFooterPattern_under(this.questionData);
    this.setTypeLayout();
    if (this.questionData.question.question_image) {
      this.questionImgUrl = this.globalService.getImageUrl(this.questionData.question.question_image);
    }
    let answer_choice=this.globalService._setChoice(this.questionData);//回答したもの
    if(answer_choice>0){
      if (answer_choice==1 && this.questionData.question.feedback_image) {
        this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image);
      }else if (answer_choice==2 && this.questionData.question.feedback_image2) {
        this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image2);
      }else if (answer_choice==3 && this.questionData.question.feedback_image3) {
        this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image3);
      }else if (answer_choice==4 && this.questionData.question.feedback_image4) {
        this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image4);
      }
    }else{
        if (this.questionData.question.feedback_image) {
          this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image);
        }
    }

    if(this.questionData.question.type==3){
      this.Type3=true;
      this.isChoose=false;
      this.isUnableToAnswer=true;
    }

  }

  setTypeLayout() {
    this.isChoose = true;
    if (this.questionData.question.type === this.questionHelper.getValue('essay')) {
      this.isChoose = false;
    }
  }

  showHeaderTitle() {
    //let title = this.questionDay;
    const questionNumber = (parseInt(this.questionNo) <= 50) ? this.circleNumberHelper.getString(parseInt(this.questionNo)) : this.questionNo;
    
    let title = 'トレーニング' + this.questionData.question.question_group;
    title += "（" + this.questionPosition + " / " + this.questionTotal + "）";

    return title;
  }

  showTextLine() {
    let textLine = '【選択肢】';

    if (!this.isChoose) {
      textLine = '【回答】';
    }

    return textLine;
  }

  showLabelCorrectOrFalse() {
    let text = '不正解です';

    if (this.questionData.result) {
      text = '正解です';
    }

    return text;
  }

  _onErrorImg(type) {
    if (type == 'footer') {
      this.feedbackImgUrl = '';
    } else if (type == 'header') {
      this.questionImgUrl = '';
    }
  }

  showChoicesOptions(choice) {
    let result;
    result = this.choiceAnswerHelper.getString(choice);

    return result;
  }

  showAnsweredDate(date) {
    return moment(date).format('YYYY/MM/DD HH:mm');
  }

  modalStudent(form: NgForm): void {
    console.log(form);
  }

  closeAndOpenModal(itemdata){
    this.bsModalRef.hide();
    //親へイベントを通知
    this.clickPrevNextButton.emit({data: itemdata});
  }

  

}


// WEBPACK FOOTER //
// ./src/app/component/customer/commentary-modal/student-modal.component.ts